
import PropTypes from 'prop-types'
import { Button as UIButton } from '@mui/material'
import { useNavigate } from 'react-router-dom'

const Button = ({ children, className, to, ...props }) => {
  const navigate = useNavigate()

  const onClick = () =>
    navigate(to)

  return (
    <UIButton
      onClick={onClick}
      {...props}>
      {children}
    </UIButton>
  )
}

Button.propTypes = {
  children: PropTypes.string.isRequired,
  className: PropTypes.string,
  to: PropTypes.string.isRequired,
}

export default Button
